module.exports = {
  message: {
    service_desc: 'Use the utility to swap COS between different formats including <strong>native COS, BEP2, and ERC-20.',
    choose_token_type: 'Choose your cos format',
    fee_tips: 'If the number of swap is greater than 500, 50 cos will be charged as a handling fee \' +\n' +
      '        \'If it is less than 500, 10% of the swap amount will be charged as a handling fee.',
    token_type_erc20_to_bep2: 'ERC-20 to BEP2',
    token_type_erc20_to_native: 'ERC-20 to native COS',
    token_type_bep2_to_erc20: 'BEP2 to ERC-20',
    token_type_bep2_to_native: 'BEP2 to native COS',
    token_type_native_to_erc20: 'native COS to ERC-20',
    token_type_native_to_bep2: 'native COS to BEP2',
    enter_address: 'Enter your address or account',
    enter_exchange_memo: 'Enter your Exchange memo',
    create_account_tips: 'Don\'t have an account? Create one',
    next_btn: 'NEXT',
    start_over_btn: 'Start over',
    ready_to_swap: 'Ready to swap',
    transfer_prefix: 'Transfer your {token} to',
    address: 'Address',
    memo: 'Memo',
    auto_swap_desc: 'Make sure you enter the ADDRESS and MEMO correctly.Swap token utility will send out the corresponding amount of COS token below wallet once receiving your token.<strong>The process may take about 5 minutes<strong>.',
    main_net_address: 'COS MainNet Address',
    bep2_address: 'BEP2 Address',
    erc20_address: 'ERC-20 Address',
    main_net_token: 'native COS',
    bep2_token: 'COS-BEP2',
    erc20_token: 'COS-ERC20',
    ok: 'Okay',
    Cancel: 'Cancel',
    tips: 'Tips',
    enter_address_tips: '最初に正しいトークンアドレスを入力してください\n',
    enter_exChange_memo_tips: 'Please fill in the exchange memo',
    swap_address_invalid: 'swap address is invalid',
    swap_address_not_exit: 'Account does not exist',
    swap_type_invalid: 'invalid swap type',
    swap_system_error: 'System error occurred. Please try again later.',
    swap_unknown_error: 'Unknown error occurred. Please try again later.',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number'
  }
}
